<template>
  <section class="flex flex-column flex-justify-start p-2">
    <article class="flex flex-column flex-justify-start flex-align-start">
      <h1>{{ $t('header.games') }}</h1>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60 article-text">
        <h4>
          {{ $t('games.latest_games') }}
        </h4>
        <div v-if="this.games.length > 0" class="flex flex-wrap">
          <div v-for="game in this.games" :key="game.id" class="flex flex-column flex-justify-center mb-2 page-content">
            <a
              title="Game"
              target="_blank"
              class="flex flex-column flex-align-start page-content-link"
              :href="game.url"
            >
              <p class="mt-2 mb-2 page-content-title">
                <b>{{ game.title }}</b>
                <br/>
                {{ $t('games.downloads') }}: {{ humanFormat(Number(game.downloads_count), { maxDecimals: 1 }) }}
              </p>
              <div class="pb-4">
                <img :src="game.cover_url" alt="Thumbnail" class="page-content-thumbnail">
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          {{ $t('games.loading') }}...
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { getPublishedGames } from '@/services/api'
import humanFormat from 'human-format'

export default {
  computed: {
    ...mapGetters([]),
    ...mapState(['games']),
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(['setGames']),
    humanFormat,
  },
  async mounted() {
    if (Object.keys(this.games).length === 0 || this.games.length === 0) {
      const { games } = await getPublishedGames();
      this.setGames(games);
    }
  },
  beforeDestroy() {},
}
</script>

<style scoped>
section {
  min-height: calc(100vh - 80px);
  width: auto;
}

section > article {
  height: auto;
  padding: 10px;
}

section > article > div {
  height: 100%;
  padding: 40px;
  border-radius: 1em;
  background: #efefef;  /* fallback for old browsers */
  background: -webkit-linear-gradient(145deg, #efefef 25%, #fff 100%);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(145deg, #efefef 25%, #fff 100%); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.article-text {
  animation: slide-up 1s ease;
}

section > article > p {
  font-size: 14px;
}

.page-content-link {
  box-sizing: border-box;
  border-radius: 0.3em;
  text-align: center;
  cursor: pointer;
  transition: background-color .35s, transform .35s;
  text-decoration: none;
  color: #000;
}

.page-content {
  width: fit-content;
  transition: .5s;
}

.page-content:hover {
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
  background-color: rgba(0, 0, 0, 0.1);
  transform: scale(1.025);
}

.page-content-title {
  width: 100%;
  max-width: 320px;
  text-align: center;
}

.page-content-thumbnail {
  width: 100%;
  max-width: 320px;
  height: auto;
  border-radius: 1em;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
}
</style>